import { Component, FC } from 'react';

import { MESSAGES } from '../../../../constants';
import { TItem } from '../../../common/reducers/types';
import { AIArticleAnswer } from '../AIArticleAnswer';
import { ArticlePreview } from '../Article';
import { ArticleSelector } from '../ArticleSelector';
import { BotMessage } from '../BotMessage';
import { BotTyping } from '../BotTyping';
import { Buttons } from '../Buttons';
import { Category } from '../Category';
import { DomainSelector } from '../DomainSelector';
import { Image } from '../Image';
import { InvoiceSelector } from '../InvoiceSelector';
import { AgentMessage, AgentStatus, ChatTransferred, ModeMessage } from '../LiveChat';
import { ConnectingAgent } from '../LiveChat/ConnectingAgent';
import { WaitingForAgent } from '../LiveChat/WaitingForAgent';
import { LoginSelector } from '../LoginSelector';
import { PhoneSelector } from '../PhoneSelector';
import { PlanSelector } from '../PlanSelector';
import { SiteSelector } from '../SiteSelector';
import { SuggestionSelector } from '../SuggestionSelector';
import { TicketSelector } from '../TicketSelector';
import { UserAccountsSelector } from '../UserAccountsSelector';
import { UserMessage } from '../UserMessage';
import { Video } from '../Video';
import { WhitelabelSelector } from '../WhitelabelSelector';

type TMessageMap = {
  readonly [K in MESSAGES]: typeof Component | FC<TItem>;
};

const map: TMessageMap = {
  // Chatbot
  [MESSAGES.ARTICLE]: ArticlePreview,
  [MESSAGES.ARTICLE_SELECTOR]: ArticleSelector,
  [MESSAGES.AI_ARTICLE_ANSWER]: AIArticleAnswer,
  [MESSAGES.BOT_MESSAGE]: BotMessage,
  [MESSAGES.TITLE_BOT_MESSAGE]: BotMessage,
  [MESSAGES.BOT_TYPING]: BotTyping,
  [MESSAGES.USER_MESSAGE]: UserMessage,
  [MESSAGES.BUTTONS]: Buttons,
  [MESSAGES.BUTTONS_VERTICAL]: Buttons,
  [MESSAGES.PHONE]: PhoneSelector,
  [MESSAGES.VIDEO]: Video,
  [MESSAGES.IMAGE]: Image,
  [MESSAGES.CATEGORY]: Category,
  [MESSAGES.SITE_SELECTOR]: SiteSelector,
  [MESSAGES.DOMAIN_SELECTOR]: DomainSelector,
  [MESSAGES.PLAN_SELECTOR]: PlanSelector,
  [MESSAGES.INVOICE_SELECTOR]: InvoiceSelector,
  [MESSAGES.SUGGESTION_SELECTOR]: SuggestionSelector,
  [MESSAGES.TICKET_SELECTOR]: TicketSelector,
  [MESSAGES.LOGIN_SELECTOR]: LoginSelector,
  [MESSAGES.USER_ACCOUNTS_SELECTOR]: UserAccountsSelector,
  [MESSAGES.CONNECTING_AGENT]: ConnectingAgent,
  [MESSAGES.WHITELABEL_SELECTOR]: WhitelabelSelector,
  // Live chat
  [MESSAGES.CHANGE_MODE]: ModeMessage,
  [MESSAGES.AGENT_STATUS]: AgentStatus,
  [MESSAGES.AGENT_MESSAGE]: AgentMessage,
  [MESSAGES.CHAT_TRANSFERRED]: ChatTransferred,
  [MESSAGES.WAITING_FOR_AGENT]: WaitingForAgent,
};

export const router = (type: MESSAGES) => map[type];
